import { ThemeOptions } from "@mui/material";

const typography: ThemeOptions["typography"] = {
  fontFamily: ["Montserrat"].join(","),
  h1: {
    fontWeight: 600,
    letterSpacing: "-0.01562em",
  },
  h2: {
    fontWeight: 600,
    letterSpacing: "-0.00833em",
  },
  h3: {
    fontWeight: 600,
    letterSpacing: "0em",
  },
  h4: {
    fontWeight: 600,
    letterSpacing: "0.00735em",
  },
  h5: {
    fontWeight: 600,
    letterSpacing: "0em",
  },
  h6: {
    fontWeight: 500,
    letterSpacing: "0.0075em",
  },
  subtitle1: {
    fontWeight: 600,
    letterSpacing: "0.00938em",
  },
  subtitle2: {
    fontWeight: 600,
    letterSpacing: "0.00714em",
  },
  body1: {
    fontWeight: 400,
    letterSpacing: "0.00938em",
  },
  body2: {
    fontWeight: 400,
    letterSpacing: "0.01071em",
  },
  button: {
    fontWeight: 500,
    letterSpacing: "0.02857em",
    textTransform: "none",
  },
  caption: {
    fontWeight: 400,
    letterSpacing: "0.02857em",
  },
  overline: {
    fontWeight: 400,
    letterSpacing: "0.08333em",
    textTransform: "uppercase",
  },
};

export default typography;
